import angular from 'angular';


import '../../../services/contract';
import '../../../services/user';

angular.module('folkeuni').component('contractsCalendar', {
  templateUrl: '/shop-dist/templates/contracts-calendar.html?c=' + window.cacheBurst,
  transclude: false,

  controller: function(Contract, User, $timeout, $scope) {
    var $ctrl = this;
    
    $ctrl.contractlines  = [{
      eventId: "",
      title: "",
      description: "",
      employeeTitle: "",
      attendance: "",
      hasEnded: "",
      endDate: "",
      hotelInvoice: "",
      lineNo: "",
      payrollType: "",
      physicalAttachment: "",
      remuneration: "",
      remunerationQuantity: "",
      startDate: "",
      location: [{
        id: 123,
        name: "",
        postalCode: "",
        address: "",
        city: ""
      }]
    }];


    $ctrl.googleCalendar = function (item) {
        var googleStartString = item.startDate;
        var googleEndString = item.endDate;
        var googleStartDate = googleStartString.replace(/-|:/g, "");
        var googleEndDate = googleEndString.replace(/-|:/g, "");

        $ctrl.googleStartDateTest = googleStartDate;
        $ctrl.googleEndDateTest = googleEndDate;
    }

    $ctrl.$onInit = function() {
    
      User.getCurrent().then(function(userObj) {
        $ctrl.userCurrent = userObj;

        Contract.getAllEvents().then(function(contractlinesObj) {
          $ctrl.contractlines = contractlinesObj;
          $ctrl.loading = false;
          }, function(errorReponse) {
          $ctrl.loading = false;
        });

      }, function(errorResponse) {
        $ctrl.loading = false;
      });
    }
  }
});
